import React from "react";
import PropTypes from "prop-types";

const CornerDragIcon = ({innerRef, ...props}) => {
  const {onMouseDown, onMouseUp, onTouchEnd} = props;
  return (
    <svg
      ref={innerRef}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 6 6"
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        padding: "0 3px 3px 0",
      }}
      width="10px"
      height="10px"
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      <g opacity="0.5">
        <path
          d="M 6 6 L 0 6 L 0 4.2 L 4 4.2 L 4.2 4.2 L 4.2 0 L 6 0 L 6 6 L 6 6 Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

CornerDragIcon.propTypes = {
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({current: PropTypes.any}),
  ]),
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchEnd: PropTypes.func,
};

export default CornerDragIcon;
